import { render, staticRenderFns } from "./ManageBankAccount.vue?vue&type=template&id=228d8411&"
import script from "./ManageBankAccount.vue?vue&type=script&lang=js&"
export * from "./ManageBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./ManageBankAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports